import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast, ToastContainer } from 'react-toastify';
import {
  CloseNotificationButton,
  DownloadStatusType,
  ToastNotification
} from '../../Scss/Custom/ReactToastify/ToastNotification';
import { connect } from 'react-redux';
import { ReportStatus } from '../../Reducks/Reports/ReportsActions';
import { reportActions } from '../../Reducks/Reports';
import Modal from 'react-modal';
import { Button } from 'reactstrap';
import './Notification.css';

export class Notification extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    reduced_reports: PropTypes.object,
    triggerPauseDownload: PropTypes.func,
    cancelDownload: PropTypes.func,
    resumeDownload: PropTypes.func,
    sendReportByEmail: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      isAlertDialogOpen: false
    };
    this.toastId = null;
    this.onClose = props.onClose;
    this.triggerPauseDownload = this.props.triggerPauseDownload.bind(this);
    this.cancelDownload = this.props.cancelDownload.bind(this);
    this.resumeDownload = this.props.resumeDownload.bind(this);
    this.sendReportByEmail = this.props.sendReportByEmail.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isBig } = this.props;
    if (isBig && prevProps.reduced_reports.reportFetchStatus !== this.props.reduced_reports.reportFetchStatus) {
      switch (this.props.reduced_reports.reportFetchStatus) {
        case ReportStatus.FETCHING:
          this.notifyReportGenerating();
          break;
        case ReportStatus.COMPLETED:
          this.notifyReportGenerated();
          break;
        case ReportStatus.FAILED:
          this.notifyReportGenerationFailure();
          break;
        case ReportStatus.PAUSED:
          this.setState({ isAlertDialogOpen: true });
          break;
        case ReportStatus.DELAYED:
          this.setState({ isAlertDialogOpen: true });
          break;
        default:
          break;
      }
    }
  }

  render() {
    const { reportFetchStatus } = this.props.reduced_reports;
    return (
      <div>
        {reportFetchStatus === ReportStatus.DELAYED ? this.generateEmailAlert() : ''}
        {reportFetchStatus === ReportStatus.PAUSED ? this.generateCancelDownloadAlert() : ''}
        <ToastContainer
          autoClose={false}
          hideProgressBar={true}
          newestOnTop={true}
          pauseOnVisibilityChange
          draggable={true}
          closeButton={<CloseNotificationButton />}
        />
      </div>
    );
  }

  notifyReportGenerating = () => {
    const { t } = this.context;
    this.toastId = toast(
      <ToastNotification
        type={DownloadStatusType.PROGRESSING}
        title={t('generateReport.downloadStatus.progress.title')}
        description={t('generateReport.downloadStatus.progress.description')}
      />,
      {
        className: `toast-background ${DownloadStatusType.PROGRESSING}`,
        position: 'bottom-left',
        closeOnClick: false,
        onClose: () => {
          this.triggerPauseDownload();
          this.toastId = null;
        }
      }
    );
  };
  notifyReportGenerated = () => {
    const { t } = this.context;
    const props = {
      className: `toast-background ${DownloadStatusType.SUCCESS}`,
      closeOnClick: true,
      autoClose: 10000,
      onClose: ''
    };
    let successTemplate;
    if (!this.props.reduced_reports.sendReportByEmail) {
      successTemplate = (
        <ToastNotification
          type={DownloadStatusType.SUCCESS}
          title={t('generateReport.downloadStatus.success.title')}
          description={t('generateReport.downloadStatus.success.description')}
        />
      );
    } else {
      props.autoClose = 2500;
      successTemplate = (
        <ToastNotification
          type={DownloadStatusType.SUCCESS}
          title={t('generateReport.downloadStatus.emailSuccess.title')}
          description={t('generateReport.downloadStatus.emailSuccess.description')}
        />
      );
      this.sendReportByEmail();
    }
    if (this.toastId !== null) {
      toast.update(this.toastId, { ...props, render: successTemplate });
    } else {
      this.toastId = toast(successTemplate, { ...props });
    }
  };
  notifyReportGenerationFailure = () => {
    const { t } = this.context;
    if (this.toastId !== null) {
      toast.update(this.toastId, {
        className: `toast-background ${DownloadStatusType.FAILURE}`,
        closeOnClick: true,
        onClose: '',
        autoClose: 10000,
        render: (
          <ToastNotification
            type={DownloadStatusType.FAILURE}
            title={t('generateReport.downloadStatus.failure.title')}
            description={t('generateReport.downloadStatus.failure.description')}
          />
        )
      });
    } else {
      this.toastId = toast(
        <ToastNotification
          type={DownloadStatusType.FAILURE}
          title={t('generateReport.downloadStatus.failure.title')}
          description={t('generateReport.downloadStatus.failure.description')}
        />,
        {
          className: `toast-background ${DownloadStatusType.FAILURE}`,
          position: 'bottom-left',
          autoClose: 10000,
          closeOnClick: true,
          onClose: ''
        }
      );
    }
  };

  generateEmailAlert = () => {
    this.dismissAll();
    const { t } = this.context;
    return (
      <Modal
        isOpen={this.state.isAlertDialogOpen}
        onRequestClose={() =>
          this.setState({
            isAlertDialogOpen: false
          })
        }
        overlayClassName="generateReportDownloadPauseOverlayModal"
        shouldCloseOnOverlayClick={false}
        className="generateReportDownloadPauseModalCss">
        <div className="reportAlert">
          <div className="generateEmailAlertTopLine" />

          <button
            className="closeButton"
            onClick={() => {
              this.setState({ isAlertDialogOpen: false });
            }}>
            <i className="togo-icon togo-icon-closes" />
          </button>
          <div className="content">
            <p className="title">{t('generateReport.downloadStatus.followUpEmailAlertTitle')}</p>
            <br />
            <p className="description">{t('generateReport.downloadStatus.followUpEmailAlertDescription')} </p>
            <br />
            <div className="text-right">
              <Button color="primary" onClick={() => this.setState({ isAlertDialogOpen: false })}>
                {t('buttons.okay')}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  generateCancelDownloadAlert = () => {
    this.dismissAll();
    const { t } = this.context;
    return (
      <Modal
        isOpen={this.state.isAlertDialogOpen}
        onRequestClose={() => this.setState({ isAlertDialogOpen: false })}
        className="generateReportDownloadPauseModalCss"
        overlayClassName="generateReportDownloadPauseOverlayModal"
        shouldCloseOnOverlayClick={false}>
        <div className="reportAlert">
          <div className="cancelDownloadAlertTopLine" />

          <button
            className="closeButton"
            onClick={() => {
              this.setState({ isAlertDialogOpen: false });
              this.cancelDownload();
            }}>
            <i className="togo-icon togo-icon-closes" />
          </button>
          <div className="content">
            <p className="title">{t('generateReport.downloadStatus.cancelDownloadAlertTitle')}</p>
            <br />
            <p className="description">{t('generateReport.downloadStatus.cancelDownloadAlertDescription')}</p>
            <br />
            <div className="d-flex justify-content-between">
              <Button
                color="link"
                onClick={() => {
                  this.setState({ isAlertDialogOpen: false });
                  this.cancelDownload();
                }}>
                {t('buttons.cancelDownload')}
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  this.setState({ isAlertDialogOpen: false });
                  this.resumeDownload();
                }}>
                <div>{t('buttons.resumeDownload')}</div>
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  dismissAll = () => toast.dismiss();
}

export default connect(
  state => ({
    reduced_reports: state.reduced_reports
  }),
  dispatch => ({
    triggerPauseDownload: () => dispatch(reportActions.pauseDownload()),
    cancelDownload: () => dispatch(reportActions.cancelDownload()),
    resumeDownload: () => dispatch(reportActions.resumeDownload()),
    sendReportByEmail: () => dispatch(reportActions.sendReportByEmail())
  })
)(Notification);



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Notification.js